import CRUDService from "./CRUDService";

class UserCategoryService extends CRUDService {
  constructor() {
    super("user-categories");
  }
}

export default new UserCategoryService();
